module.exports = __webpack_public_path__ + "static/media/individual.b33e0932.jpg";